import { Box, Button, Text, Title } from '@nimbus-ds/components';
import { useTranslationMarketing } from 'domains/Marketing/hook';

interface PaymentOptionListEmptyProps {
  handleGoToPayments: () => void;
  translationKey: string;
}

export function PaymentOptionListEmpty({
  handleGoToPayments,
  translationKey,
}: Readonly<PaymentOptionListEmptyProps>): JSX.Element {
  const t = useTranslationMarketing(
    `promotions.settingsPage.limits.paymentOptions.modal.${translationKey}`,
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      gap="3"
      paddingTop="5"
    >
      <Title as="h4">{t('title')}</Title>
      <Text color="neutral-textLow">{t('text')}</Text>
      <Button appearance="primary" onClick={handleGoToPayments}>
        {t('ctaText')}
      </Button>
    </Box>
  );
}
